import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from "@angular/router";
import { Observable } from "rxjs";
import { Auth } from 'aws-amplify';
import { UsersService } from "../users/users.service";

@Injectable({
  providedIn: "root",
})
export class AdminAuthGuard implements CanActivate {
  
  constructor(private router: Router, private userService: UsersService) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const isAdmin = await this.userService.isAuthenticatedUserClientAdmin();
      
      if (!isAdmin) {
        this.router.navigate(["/"]);
        return false;
      }
      
      return true;
    } catch (error) {
      this.router.navigate(["/signin"]);
      return false;
    }
  }
}
